import React, { useEffect, useState } from 'react';
import axios from 'axios';
import API_BASE_URL from '../api';
import { FaStar, FaRegStar, FaQuoteLeft } from 'react-icons/fa';

// Curated, positive reviews first (used for the compact home-page teaser),
// the rest of the real review spread (including a few critical ones, for an
// honest full picture) follows after for the dedicated /reviews page.
const fallbackReviews = [
  {
    customerName: 'Flyer33958112579',
    rating: 5,
    text:
      "We had a stay near Hiwa boutique hotel, the stay was great. The service was awesome with taste, my children and my wife there enjoy the tasty food. The amenities in rooms where good. It's near to Ramoji Film City. We would highly recommend this hotel.",
  },
  {
    customerName: 'Jay Ravi',
    rating: 5,
    text:
      'We had a good time at the hotel and is neat and clean. All the staffs were polite and friendly and have responded to each and every query patiently. OVERALL a Great Experience. Food taste can be improved however the quality is very good.',
  },
  {
    customerName: 'Soni Ramavath',
    rating: 5,
    text:
      'I recently stayed at Hiwa Boutique Hotel near Medipally, and it was a great experience. The hotel is very clean and well-maintained, with spacious rooms and all the necessary amenities. Highly recommend for a peaceful and enjoyable stay!',
  },
  {
    customerName: 'Umesh Ummu',
    rating: 4,
    text:
      'The maintenance is excellent, the food quality is good, and the room is clean. I am very happy with the service.',
  },
  {
    customerName: 'Nanda Kishore',
    rating: 5,
    text: 'Near to Ramoji Film City, Room are comfortable, we would recommend this hotel',
  },
  {
    customerName: 'Akshay Kumar',
    rating: 5,
    text:
      'For couple plz chose delux rooms or suit because executive is smaller .. and its for single person use thats it… everything else is perfect ..',
  },
  {
    customerName: 'Nakka Ankarao',
    rating: 5,
    text:
      "Stayed at Hiwa Boutique Hotel near Medipally and had a great experience. The hotel is new, and the rooms are really luxurious at a reasonable price. The place is well-maintained, and the food is delicious. Definitely worth considering if you're looking for a good stay with great food.",
  },
  {
    customerName: 'V K',
    rating: 5,
    text:
      'I loved my experience. The ambiance is so good and peaceful, the food was unique and delicious, I tried their Jonna Rotte & Raagi sangati, where they nailed the flavours, and the staff is professional and pays attention to their customers.',
  },
  {
    customerName: 'KK',
    rating: 5,
    text:
      'I had a very pleasant stay at Hiwa Boutique Hotel in Boduppal. The rooms were neat, well-maintained, and comfortable, making it a great option for both business and family stays.',
  },
  {
    customerName: 'jatothu puneethnayak',
    rating: 5,
    text:
      'Stopped by Narapally recently and was impressed with the cleanliness of the hotel; everything was spotless. The staff was friendly and attentive, making sure we had everything we needed without being intrusive. The food was quite good, with a nice variety on the menu. Overall, I felt like I got good value for my stay. Glad we came.',
  },
  {
    customerName: 'KBR Official',
    rating: 5,
    text:
      "We celebrated our son Bhargavram's 1st Birthday on 19th April 2026 at Hiwa Boutique Hotel, Medipally, and it was truly a wonderful and memorable experience.",
  },
  {
    customerName: 'AADITYA S DAS',
    rating: 4,
    text:
      'The rooms and overall hotel were clean and well-maintained, with excellent amenities and toiletries for the price. The deal was truly great, and the rooms exceeded expectations for this price range.',
  },
  {
    customerName: 'SAYAN CHATTERJEE',
    rating: 4,
    text:
      'We had a stay for one night at this hotel at Hyderabad. This hotel is located near Bod Uppal at a distance of around 9 km to the Cherlapally station.',
  },
  {
    customerName: 'Shayantani Paul',
    rating: 5,
    text:
      "It's the best hotel at affordable price that you can find around charlapalli railway station. From receptionists to managers the staffs are all well mannered, and helpful.",
  },
  {
    customerName: 'Dr. Neel Prakash',
    rating: 5,
    text: 'Very good hotel. Nice service. Ambience is great.Near to centre. I recommended to book this hotel.',
  },
  {
    customerName: 'Venkatesh Krishna',
    rating: 5,
    text:
      'Excellent and well maintained rooms. We booked in MMTP got the room for best price.',
  },
  {
    customerName: 'Santosh Pawar',
    rating: 5,
    text:
      'Had an amazing experience at Hiwa Boutique Hotel! The rooms are stylish, clean, and comfortable, with great attention to detail. The staff is incredibly welcoming and attentive, making the stay even more enjoyable.',
  },
  {
    customerName: 'GOPIKA P',
    rating: 5,
    text:
      'My father and I recently stayed at Hiwa Boutique Hotel, and it was an excellent choice, especially since I had an exam nearby.',
  },
  {
    customerName: 'Ravi kumar',
    rating: 5,
    text: 'Good Stay , the checkin was smooth, Nonveg buffet was tasty 🤤 All thanks for Manoj sir.. I would recommend this hotel for my company',
  },
  {
    customerName: 'Giri Sundar',
    rating: 5,
    text: 'Nice one ...The Night shift guy in reception was very helpful...Over All Very Good Stay ...Food was Also good',
  },
  {
    customerName: 'Subashini S',
    rating: 5,
    text: 'Had a great and comfortable stay . Felt at home and the location I must stay so quiet',
  },
  {
    customerName: 'mounikac611',
    rating: 5,
    text:
      'The room was clean, comfortable, and had everything I needed for a pleasant stay. The bed was very cosy, and I enjoyed the peaceful atmosphere. The bathroom was well-stocked, and the amenities were a nice touch. I would definitely recommend this hotel based on the room quality.',
  },
  {
    customerName: 'sreenu banavath',
    rating: 5,
    text:
      'I recently stayed at HIWA Boutique Hotel and had a fantastic experience! The rooms were spotless and the staff were incredibly friendly and helpful.',
  },
  {
    customerName: 'Sam L',
    rating: 5,
    text: 'Good stay. Good ambience. Good hospitality.',
  },
  {
    customerName: 'jashwanth reddy',
    rating: 5,
    text:
      "It's a pleasant experience with this hotel as it's a new property the rooms are very clean and hygienic the restaurant food Is also very tasty the staff is responding quickly to our quires. I highly recommend this hotel for my friends and my family",
  },
  {
    customerName: 'Patnaik',
    rating: 5,
    text: 'I had a wonderful stay at Hotel HIWA. The food was delicious, the service was excellent, and the ambiance was warm and inviting. Highly recommended!',
  },
  {
    customerName: 'Harsha Harsha',
    rating: 5,
    text:
      'Amazing service by Sanjeeb Tamang I would recommend this hotel 6 star but unfortunately their is only 5 star . So ya this is the best hotel I have ever visited See you again Hiwa Botique Hotel',
  },
  {
    customerName: 'Jayaprakash Narayanan',
    rating: 5,
    text: 'Good place to stay. Staff is very cooperative. Maintains cleanliness.',
  },
  {
    customerName: 'Ramesh Maloth',
    rating: 5,
    text: 'Lovely room and excellent service – everything was clean, comfortable, and the staff were so friendly. Really enjoyed my stay ❣️ Good hospitality',
  },
  {
    customerName: 'chintu vadla',
    rating: 5,
    text:
      'Very good experience with Hiwa boutique hotel wonderful service which they have provided and staff is very helpful and friendly and placed in a pleasant place which near to Uppal Medipally I haven’t expect service with this new property thank you especially for manger mahesh',
  },
  {
    customerName: 'Samprathi Sam',
    rating: 5,
    text: 'Had an amazing stay experience in this hotel, their service was really appreciable. They have best amenities provided',
  },
  {
    customerName: 'nandita Roy',
    rating: 5,
    text: 'They give excellent services. The hotel is exactly like the photos. It was in a wonderful site and incredible views.',
  },
  {
    customerName: 'Ashish Pandey',
    rating: 5,
    text: 'Came from mumbai to visite swanagiri temple and this hotel is near to the temple and had a safe stay and maintained awsome ameneties.',
  },
  {
    customerName: 'Papali Palei',
    rating: 5,
    text:
      "Very good hotel near stadium with ambience and this is the new property with reasonable price and quality of food staff was very helpful and friendly I'll recommend this hotel to my friends and family",
  },
  {
    customerName: 'Anil Bhukya',
    rating: 5,
    text: 'Had a wonderful stay at hiwa boutique hotel near medipally. Hotel is newly established, featuring elegant and luxurious rooms at an affordable rate',
  },
  {
    customerName: 'Maynard Zachariah',
    rating: 5,
    text: 'Had a great experience in staying, cleanliness of room, comfortable stay and better price range within the area of Medipally, Uppal in Hyderabad.',
  },
  {
    customerName: 'Ravi Gugulothu',
    rating: 5,
    text: "It's great experience with Hiwa. Rooms are clean and hygienic, service of staff is great and food is good",
  },
  {
    customerName: 'Jatoth chandu',
    rating: 5,
    text: 'I have never seen such building like this 😱😱. Amenities r best and perfect in the uppal are. Must visit the hotel for best experience',
  },
  {
    customerName: 'bharath adla',
    rating: 5,
    text: 'Recently visited there for breakfast Nice Food and quality Neat mantainance',
  },
  {
    customerName: 'venkat narayana',
    rating: 5,
    text: 'Its nice place to stay on official tours',
  },
  {
    customerName: 'Ashok Kumar',
    rating: 5,
    text: 'We had natukodi pulusu and ragi sangati and jonna roti, the food was delicious, loved it😋',
  },
  {
    customerName: 'HARI KRISHNA GURRAM',
    rating: 5,
    text: 'Hotel is superb Hospitality 5 out of. 5 Service 5 out of 5 Neat and cleaness 5 out of 5',
  },
  {
    customerName: 'a karthii',
    rating: 5,
    text: "It's a wonderful experience with hiwa Good manner of approach nd service food was delicious nd ambiance also very nice",
  },
  {
    customerName: 'Bhaskar B',
    rating: 5,
    text: 'Good access from main road, well & good staff, VFM stay with complimentary breakfast 👌👍',
  },
  {
    customerName: 'MANISHA RATHOD',
    rating: 5,
    text: 'Had a great family stay , great service, location and cleanliness.',
  },
  {
    customerName: 'Rohit B Nagaraj',
    rating: 5,
    text: 'Good and Hygiene. Need to improve on service',
  },
  {
    customerName: 'viswanadham akondi',
    rating: 4,
    text: 'Ok good place but need proper maintenance of property',
  },
  {
    customerName: 'Manoj',
    rating: 3,
    text:
      "For staying in a this hotel is perfect but not for FOOD or room service very poor service & quality, don't book food when you are booking this hotel order from outside there are lots restaurant. Specially breakfast was very bad only 1 or 2 items are there.",
  },
  {
    customerName: 'Anjali Bagga',
    rating: 2,
    text:
      'While Hiwa Boutique Hotel is a new facility with clean rooms, several critical issues overshadow the stay experience. The staff, though well-meaning, often crosses boundaries and intrudes on guest privacy.',
  },
  {
    customerName: 'Tikari_state',
    rating: 1,
    text:
      'This is really sad to share it here but they always change the price of hotel. In my recent visit to this hotel i found the staff is not well behaved as they were asking for extra money on the name of upgradation.',
  },
  {
    customerName: 'Muskhan Padhi',
    rating: 1,
    text:
      "Worst experience due to only one reason, the restaurant staff girl don't know her name (girl with bob cut and red hair), secretly was taking our video without our consent when we were eating in restaurant, it felt really unsafe.",
  },
  {
    customerName: 'Sandy Chandu',
    rating: 1,
    text:
      'Visited the restaurant. All I can say is this place is overly priced, under quality food for street side menu and under size portion of food. Nothing botique about food. Regular street side menu, other state serving faces with cold attitude and banquet hall ambience.',
  },
  {
    customerName: 'Abhi Ram',
    rating: 1,
    text:
      'In this hotel page there is some thing here there is nothing like that they not provided tiffin and even plate to eat for free and they charging for disposal plates and the way they behave is not good totally wast of money.',
  },
  {
    customerName: 'Ravindra Kaushik',
    rating: 1,
    text: 'Bad service and no good food without a proper lock in the room.',
  },
];

const fallbackSummary = { rating: 4.4, total: 117 };

const StarRating = ({ rating }) => (
  <div className="flex gap-0.5 text-accent text-sm">
    {Array.from({ length: 5 }, (_, index) =>
      index < rating ? <FaStar key={index} /> : <FaRegStar key={index} />
    )}
  </div>
);

const ReviewCard = ({ review, className = '' }) => (
  <div className={`rounded-2xl bg-primary text-white p-5 sm:p-6 shadow-lg flex flex-col ${className}`}>
    <div className="flex items-center justify-between gap-3 mb-4">
      <div className="flex items-center gap-3">
        {review.profilePhotoUrl ? (
          <img
            src={review.profilePhotoUrl}
            alt={review.customerName}
            className="w-11 h-11 sm:w-12 sm:h-12 shrink-0 rounded-full object-cover"
            referrerPolicy="no-referrer"
            onError={(event) => {
              event.currentTarget.style.display = 'none';
            }}
          />
        ) : (
          <span className="w-11 h-11 sm:w-12 sm:h-12 shrink-0 rounded-full bg-accent flex items-center justify-center font-bold text-primary text-lg">
            {review.customerName.charAt(0).toUpperCase()}
          </span>
        )}
        <div>
          <p className="font-semibold leading-tight">{review.customerName}</p>
          <StarRating rating={review.rating} />
        </div>
      </div>
      <span className="shrink-0 text-xs font-semibold bg-white/10 px-2.5 py-1 rounded-full">
        {review.rating}/5
      </span>
    </div>

    <FaQuoteLeft className="text-accent/60 text-xl mb-2" />
    <p className="text-gray-300 text-sm leading-relaxed">{review.text}</p>
  </div>
);

const CustomerFeedback = ({ limit = 8, layout = 'grid' }) => {
  const [reviews, setReviews] = useState(fallbackReviews);
  const [googleSummary, setGoogleSummary] = useState(fallbackSummary);

  useEffect(() => {
    let isMounted = true;

    const loadGoogleReviews = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/google-reviews`);
        const data = response.data;
        if (!isMounted || !data?.reviews?.length) return;

        setReviews(data.reviews);
        if (data.rating && data.userRatingsTotal) {
          setGoogleSummary({ rating: data.rating, total: data.userRatingsTotal });
        }
      } catch (error) {
        // Keep showing the fallback reviews already on screen.
        console.error('Error loading Google reviews:', error);
      }
    };

    loadGoogleReviews();
    return () => {
      isMounted = false;
    };
  }, []);

  return (
    <section className="pt-0 lg:pt-4 pb-8 lg:pb-20" style={{ background: '#FFFFE7' }}>
      <div className="container mx-auto lg:px-0 rounded-3xl p-4 sm:p-6 lg:p-10 shadow-xl bg-white/80">
        <div className="text-center mb-6 sm:mb-8 lg:mb-10">
          <div className="font-tertiary uppercase text-lg sm:text-[25px] tracking-[3px] sm:tracking-[6px]">
            Testimonials
          </div>
          <h2 className="font-primary text-3xl sm:text-4xl lg:text-[45px]">Our Customers Feedback</h2>
          <p className="text-gray-500 mt-2 max-w-xl mx-auto text-sm sm:text-base px-2">
            Your comfort and happiness inspire us every day.
          </p>
          {googleSummary && (
            <div className="inline-flex items-center gap-2 mt-3 text-sm font-semibold text-gray-700 bg-gray-100 px-3 py-1.5 rounded-full">
              <FaStar className="text-accent" />
              {googleSummary.rating} on Google &middot; {googleSummary.total} reviews
            </div>
          )}
        </div>

        {layout === 'row' ? (
          <div className="flex gap-4 sm:gap-6 overflow-x-auto snap-x snap-mandatory pb-3 -mx-1 px-1">
            {reviews.slice(0, limit).map((review) => (
              <ReviewCard
                key={review.customerName}
                review={review}
                className="min-w-[260px] sm:min-w-[320px] max-w-[320px] shrink-0 snap-start"
              />
            ))}
          </div>
        ) : (
          <div className="max-h-[1100px] overflow-y-auto pr-1 sm:pr-2">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6">
              {reviews.slice(0, limit).map((review) => (
                <ReviewCard key={review.customerName} review={review} />
              ))}
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default CustomerFeedback;
